export const authConfig = {
    domain: import.meta.env.VITE_ZERO_DOMAIN as string,
    clientId: import.meta.env.VITE_ZERO_CLIENT_ID as string,
    authorizationParams: {
        redirect_uri: `${window.location.origin}/callback`,
        audience: import.meta.env.VITE_ZERO_AUDIENCE as string,
        scope: 'openid profile email manage:users update:user_roles'
    },
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
};